import PricesRow from './PricesRow';

export default PricesRow;


// WEBPACK FOOTER //
// ./src/components/Others/PricesWithDiscountInput/components/PricesRow/index.tsx